import { cn } from "@/lib";
import { isEmpty } from "@/utils";

interface TProps {
    selectedDate: number;
    times: any;
    handleSelectTime: (time: any) => void;
}

const Times = ({ selectedDate, times, handleSelectTime }: TProps) => {
    return (selectedDate && !isEmpty(times)) && (
        <div className='flex flex-col gap-2 mt-2'>
            <p className='font-medium text-zinc-600 uppercase'>select time</p>
            <div className='grid grid-cols-2 sm:grid-cols-3 gap-2'>
                {times?.map((time: any, index: number) => (
                    <div
                        key={index}
                        onClick={() => {
                            handleSelectTime(time);
                        }}
                        className={cn(
                            'w-full flex items-center justify-center p-3 shrink-0 cursor-pointer rounded-lg border border-gray-200 bg-white transition-colors',
                            'hover:border-zinc-800 hover:bg-zinc-900 hover:text-white',
                        )}
                    >
                        <p className='text-xs sm:text-sm md:text-base font-medium'>
                            {time?.label}
                        </p>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default Times;